<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell *ngIf="!isLoading">

    <app-page-hero
        [eyebrow]="t('pages.shipmentDirectory.hero.eyebrow')"
        [title]="t('pages.shipmentDirectory.hero.title')"
        [subtitle]="t('pages.shipmentDirectory.hero.subtitle')">
    </app-page-hero>

    <app-page-data-panel
        [title]="t('pages.shipmentDirectory.dataPanel.title')"
        [subtitle]="t('pages.shipmentDirectory.dataPanel.subtitle')"
        [resultText]="getResultText()">
        <p-table
            [value]="shipmentList"
            [paginator]="true"
            [rows]="20"
            [lazy]="true"
            [totalRecords]="totalRecords || 0"
            [loading]="isLoading"
            dataKey="shipmentId"
            responsiveLayout="scroll"
            (onLazyLoad)="loadOrderList($event)">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ t('pages.shipmentDirectory.table.shipmentNumber') }}</th>
                    <th>{{ t('pages.shipmentDirectory.table.client') }}</th>
                    <th>{{ t('pages.shipmentDirectory.table.contact') }}</th>
                    <th>{{ t('pages.shipmentDirectory.table.pickup') }}</th>
                    <th>{{ t('pages.shipmentDirectory.table.dropoff') }}</th>
                    <th>{{ t('pages.shipmentDirectory.table.moveDate') }}</th>
                    <th>{{ t('pages.shipmentDirectory.table.vehicle') }}</th>
                    <th class="text-right">{{ t('pages.shipmentDirectory.table.quantity') }}</th>
                    <th>{{ t('pages.shipmentDirectory.table.status') }}</th>
                    <th class="text-center">{{ t('pages.shipmentDirectory.table.actions') }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-shipment>
                <tr>
                    <td>
                        <button type="button" class="shipment-link-button" (click)="viewDetailPage(shipment)">
                            {{ shipment.queryId || shipment.shipmentNumber || shipment.shipmentId }}
                        </button>
                    </td>
                    <td>{{ shipment.nominationPack?.receiver?.client?.name || '-' }}</td>
                    <td>{{ shipment.nominationPack?.receiver?.nominee?.name || '-' }}</td>
                    <td>
                        <p-chip icon="fa-solid fa-flag" [label]="shipment.pickupCity || '-'"></p-chip>
                    </td>
                    <td>
                        <p-chip icon="fa-solid fa-flag-checkered" [label]="shipment.dropoffCity || '-'"></p-chip>
                    </td>
                    <td>{{ shipment.requestedBookingTime ? showDate(shipment.requestedBookingTime) : '-' }}</td>
                    <td>
                        {{ shipment.vehicleParaPack?.vehicleConfig?.name || '-' }}
                        {{ shipment.vehicleParaPack?.vehicleCapacity?.name || '' }}
                    </td>
                    <td class="text-right">{{ shipment.quantityRequired || 0 }}</td>
                    <td>
                        <p-tag [value]="displayShipmentStatus(shipment)" [severity]="getSeverity(displayShipmentStatus(shipment))"></p-tag>
                    </td>
                    <td>
                        <div class="shipment-table-actions">
                            <p-button
                                icon="fa-solid fa-eye"
                                [rounded]="true"
                                [text]="true"
                                size="small"
                                [pTooltip]="t('pages.shipmentDirectory.tooltips.viewShipment', 'View shipment')"
                                [ariaLabel]="t('pages.shipmentDirectory.tooltips.viewShipment', 'View shipment')"
                                (click)="viewDetailPage(shipment)">
                            </p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="10" class="text-center py-5">
                        <i class="fa-solid fa-magnifying-glass text-primary text-xl mb-2"></i>
                        <div class="font-semibold">{{ t('pages.shipmentDirectory.empty.title') }}</div>
                        <div class="text-sm text-600">{{ t('pages.shipmentDirectory.empty.subtitle') }}</div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
